import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class FactoringTabService {


  private _getFactFolderListUrl = `${environment.api}/factTab/getFactFolderList`;
  private _getfactoringSoaListUrl = `${environment.api}/factTab/getfactoringSoaList`;
  private _getFactApiSoaUserList = `${environment.api}/factTab/getFactApiSoaUserList`;
  private _getApiFactSoaUserList = `${environment.api}/factTab/getApiFactSoaUserList`;

  private _downloadFactoringSoaListUrl = `${environment.api}/factTab/downloadFactoringSoaList`;

  constructor(private http: HttpClient) { }

  getFactFolderList(data){
    return this.http.post<any>(this._getFactFolderListUrl,data);
  }

  getfactoringSoaList(data){
    return this.http.post<any>(this._getfactoringSoaListUrl,data);
  }

  getFactApiSoaUserList(data){
    return this.http.post<any>(this._getFactApiSoaUserList,data);
  }

  getApiFactSoaUserList(data){
    return this.http.post<any>(this._getApiFactSoaUserList,data);
  }
  downloadFactoringSoaList(data){
    return this.http.post<any>(this._downloadFactoringSoaListUrl,data);
  }


 

}
